export interface ChoiceMatchCompletionScore {
  readonly score: number;
  readonly correctRate: number;
  readonly successfulChecks: number;
  readonly totalChecks: number;
  readonly retryCount: number;
  readonly hintCount: number;
}

function normalizeCount(value: number): number {
  return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;
}

export function calculateChoiceMatchCompletionScore(
  successfulChecks: number,
  retryCount: number,
  hintCount: number
): ChoiceMatchCompletionScore {
  const normalizedSuccessfulChecks = normalizeCount(successfulChecks);
  const normalizedRetryCount = normalizeCount(retryCount);
  const normalizedHintCount = normalizeCount(hintCount);
  const totalChecks = normalizedSuccessfulChecks + normalizedRetryCount;
  const correctRate =
    totalChecks === 0 ? 0 : normalizedSuccessfulChecks / totalChecks;

  return {
    score: Math.round(correctRate * 100),
    correctRate,
    successfulChecks: normalizedSuccessfulChecks,
    totalChecks,
    retryCount: normalizedRetryCount,
    hintCount: normalizedHintCount
  };
}
